import { render } from "./App.vue?vue&type=template&id=67ac188c"
const script = {}

import exportComponent from "/Users/apple/Documents/jmd/Templates/Templates/chatgpt-tpl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__